import React, { useState, useEffect } from "react";
import Grid from "@mui/material/Grid";
import Buttons from "../Button/Button";
import CheckCircleRoundedIcon from "@mui/icons-material/CheckCircleRounded";
import ArrowForwardRoundedIcon from "@mui/icons-material/ArrowForwardRounded";
import { useShoppingCart } from "../../contexts/CartContext";
import SideDrawer from "../../pages/Payments/compononents/SideDrawer/SideDrawer";
import ShoppingCart from "../../pages/Payments/forms/ShoppingCart";
export default function BottomCart(props) {
  const { updateCart, setOpenSignUpModel } = props;
  const { cartItems, setCartItems } = useShoppingCart();
  const [cartCourses, setCartCourses] = useState([]);
  const [courseTitle, setCourseTitle] = useState("");
  const [totalAmount, setTotalAmount] = useState(0);

  // ====== Payment Drawer Start======//
  const [openShoppingDrawer, setOpenShoppingDrawer] = useState(false);
  const handleOpenShoppingDrawer = () => {
    setOpenShoppingDrawer(true);
  };
  const CloseShoppingDrawer = () => {
    setOpenShoppingDrawer(false);
  };
  // ====== Payment Drawer End======//
  useEffect(() => {
    let localCourses = localStorage.getItem("selectedCourses");
    localCourses = JSON.parse(localCourses);
    if (cartItems?.length > 0) {
      let lastElement = cartItems[cartItems.length - 1];
      setCourseTitle(lastElement.courseTitle);
    } else {
      // setCourseTitle("");
    }

    let totalPrice = 0;
    localCourses?.forEach((course) => {
      totalPrice += course.price;
    });

    setCartCourses(localCourses);
    setTotalAmount(totalPrice);
  }, [cartItems]);
  const totalData = (courseData) => {
    let totalPrice = courseData?.reduce((total, data) => {
      if (
        data &&
        data.trackTermCoursesTotalPrice !== null &&
        data.trackTermCoursesTotalPrice !== undefined
      ) {
        total += parseFloat(data.trackTermCoursesTotalPrice);
      } else if (data && data.price !== null && data.price !== undefined) {
        total += parseFloat(data.price);
      }

      return total;
    }, 0);
    return totalPrice || 0;
  };

  return (
    <>
      {cartCourses?.length > 0 && (
        <div className="BottomCartSection">
          <div className="BottomCartContainer BottomCartDesktop">
            <div className="CartLeftCol">
              <CheckCircleRoundedIcon />
              {courseTitle && (
                <p>
                  You have added <a href="#"> {courseTitle} </a> to your cart!
                </p>
              )}
            </div>
            <div className="CartRightCol">
              <div className="CartRightColInfo">
                {cartItems.length > 0 ? (
                  <p>
                    {" "}
                    {cartItems.length}{" "}
                    {cartItems.length == 1 ? "item" : "items"}
                  </p>
                ) : (
                  ""
                )}
                {totalAmount > 0 && (
                  <h1>${parseFloat(totalData(cartItems))?.toFixed(2)}</h1>
                )}
              </div>

              {/* <Buttons
                label="Go to cart"
                buttonColor="#fff"
                color="#004FE0"
                width="auto"
                height="48px"
                fontSize="14px"
                border="#004FE0 1px solid"
              // onClick={showAllBtnHandler}
              /> */}

              <Buttons
                label="Continue Checkout"
                buttonColor="#004FE0"
                color="#fff"
                height="48px"
                fontSize="14px"
                border="#E4E8EC 1px solid"
                width="100%"
                // link="/shopping"
                onClick={() => handleOpenShoppingDrawer()}
                iconafter={<ArrowForwardRoundedIcon />}
              />
            </div>

            {/* <Grid container spacing={3}>
              <Grid item xs={6} sm={6} md={6}>
                {courseTitle && <p>You have added <a href="#">{courseTitle}</a> to your cart!</p>}
              </Grid>
              <Grid item xs={1} sm={1} md={1}>
                {cartCourses.length > 0 ? <p> {cartCourses.length} {cartCourses.length == 1 ? "item" : "items"}</p> : ""}
                {totalAmount > 0 && <p>${totalAmount}</p>}
              </Grid>
              <Grid item xs={5} sm={5} md={5}>
                <Buttons
                  label="Continue Checkout"
                  buttonColor="#004FE0"
                  color="#fff"
                  height="48px"
                  fontSize="14px"
                  border="#E4E8EC 1px solid"
                  width="100%"
                  link="/shopping"
                />
              </Grid>
            </Grid> */}
          </div>

          <div className="BottomCartContainer BottomCartMobile">
            <div className="CartRightCol">
              <div className="CartRightColInfo">
                {cartItems?.length > 0 ? (
                  <p>
                    {" "}
                    {cartItems?.length}{" "}
                    {cartItems?.length == 1 ? "item" : "items"}
                  </p>
                ) : (
                  ""
                )}
                {totalData(cartItems) > 0 && (
                  <h1>${parseFloat(totalData(cartItems))?.toFixed(2)}</h1>
                )}
              </div>

              <Buttons
                label="Continue Checkout"
                buttonColor="#004FE0"
                color="#fff"
                height="48px"
                fontSize="14px"
                border="#E4E8EC 1px solid"
                width="100%"
                // link="/shopping"
                onClick={() => handleOpenShoppingDrawer()}
                iconafter={<ArrowForwardRoundedIcon />}
              />
            </div>
          </div>
        </div>
      )}
      {/* === Shopping Cart Drawer Start*/}
      <SideDrawer
      drawerWidth="744px"
        padding="24px"
        title={`Shopping Cart (${cartItems?.length} Item ${
          cartItems?.length > 1 ? "s" : ""
        })`}
        sideOpen="right"
        open={openShoppingDrawer}
        handleDrawerClose={CloseShoppingDrawer}
        Headerbackground="#004FE0"
        HeaderTextColor="#fff"
        body={<ShoppingCart setOpenSignUpModel={setOpenSignUpModel} />}
      />
      {/* === Shopping Cart Drawer End*/}
    </>
  );
}
